import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { User } from "lucide-react";
import { Card, CardContent } from "./Card";
import { Badge } from "./Badge";
import { useTheme as useCustomTheme } from "../theme/useTheme";

export function EmptyStateContainer({ 
  title,
  message, 
  icon: IconComponent = User,
  badgeText = "Sin cliente seleccionado",
  variant = "primary",
  showIconBackground = true,
  iconColor,
  showBadge = true,
}) {
  const theme = useTheme();
  const { colors } = useCustomTheme();

  const getVariantColors = () => {
    switch (variant) {
      case "error":
        return {
          backgroundColor: `${colors.error.light}22`,
          iconColor: colors.error.main,
          badgeVariant: "destructive",
          badgeStyles: {
            backgroundColor: `${colors.error.light}22`,
            color: colors.error.dark,
            border: `1px solid ${colors.error.light}`,
          }
        };
      default:
        return {
          backgroundColor: `${colors.primary.light}22`,
          iconColor: colors.primary.main,
          badgeVariant: "secondary",
          badgeStyles: {}
        };
    }
  };

  const variantColors = getVariantColors();

  const resolvedIconColor = iconColor || variantColors.iconColor;

  return (
    <Card sx={{ 
      flex: 1
    }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          padding: 6,
          textAlign: "center",
          flex: 1,
        }}
      >
        <Box
          sx={{
            width: showIconBackground ? 80 : "auto",
            height: showIconBackground ? 80 : "auto",
            borderRadius: showIconBackground ? "50%" : 0,
            backgroundColor: showIconBackground
              ? variantColors.backgroundColor
              : "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconComponent size={32} color={resolvedIconColor} />
        </Box>
        
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            maxWidth: "400px",
          }}
        >
          {title && (
            <Typography
              variant="h6"
              sx={{
                fontSize: "1.125rem",
                fontWeight: 500,
                color: theme.palette.text.primary,
              }}
            >
              {title}
            </Typography>
          )}
          
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.875rem",
              color: theme.palette.text.secondary,
              lineHeight: 1.5,
            }}
          >
            {message}
          </Typography>
        </Box>
        
        {showBadge && badgeText && (
          <Badge 
            variant={variantColors.badgeVariant}
            sx={{
              ...variantColors.badgeStyles,
            }}
          >
            {badgeText}
          </Badge>
        )}
      </CardContent>
    </Card>
  );
}
